import { classNames } from "@circle-react/helpers/twMergeWithCN";

import { CouponBadge } from "./CouponBadge";
import { CouponField } from "./CouponField";
import { useCouponForm } from "./hooks/useCouponForm";

// The `shouldHideCoupon` maintain the functionality if the coupon is applied
// but does not render the badge neither the coupon input
interface CouponFormProp {
  className?: string;
  shouldHideCoupon?: boolean;
  useHooks?: () => ReturnType<typeof useCouponForm>;
}

export const CouponForm = ({
  className,
  shouldHideCoupon = false,
  useHooks = useCouponForm,
}: CouponFormProp) => {
  const { couponPreviewMutation, areCouponsEnabled, applyCoupon } = useHooks();

  if (!areCouponsEnabled || shouldHideCoupon) {
    return null;
  }

  if (couponPreviewMutation.isSuccess) {
    return (
      <div className={classNames("flex flex-col gap-y-2")}>
        <CouponBadge />
      </div>
    );
  }

  return (
    <div className={classNames("flex w-full flex-col gap-y-2", className)}>
      <CouponField applyCoupon={applyCoupon} />
    </div>
  );
};
